import { useCallback } from 'react'
import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'

import { LeadEditPage } from '#/pages/leads'
import { useEscapeClose } from '#/shared/lib/hooks'

export const Route = createFileRoute('/_shell/leads/$leadId/edit')({
  component: SubRoute,
})

function SubRoute() {
  const { leadId } = Route.useParams()
  const navigate = useNavigate()
  const listSearch = useSearch({ strict: false })
  const handleClose = useCallback(() => {
    void navigate({ to: '/leads/$leadId', params: { leadId }, search: listSearch as never })
  }, [navigate, listSearch, leadId])
  useEscapeClose(handleClose)
  return <LeadEditPage shipmentId={leadId} onClose={handleClose} />
}
